import { Component, ChangeDetectionStrategy, Input, OnChanges } from '@angular/core';

import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import * as models from './models';
import * as services from './services';
import { SettingsService } from '@app/settings.service';

@Component({
  selector: 'app-real-property-agent-feedback',
  templateUrl: './real-property-agent-feedback.component.html',
  styleUrls: ['./real-property-agent-feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RealPropertyAgentFeedbackComponent implements OnChanges {
  @Input()
  private readonly agentId: number;

  @Input() private markForUpdate: boolean;
  public agentFeedback$: Observable<models.RawAgentFeedbackResp['data']['data']['data']>;

  public pageNumber = 0;
  public totalCount = 0;

  private readonly pageSize = 1;
  isMobile: boolean;
  constructor(
    private realPropertyAgentService: services.AgentFeedbackService,
    private _settingsService: SettingsService,
  ) {}

  public ngOnChanges(): void {
    this.agentFeedback$ = this.realPropertyAgentService.getAgentFeedback(this.agentId, { pageNumber: this.pageNumber, pageSize: this.pageSize }).pipe(
      map((res) => res.data),
      tap(({ total }) => (this.totalCount = total)),
      map((data) => data.data.data),
    );

    this._settingsService.isMobile().subscribe((data) => (this.isMobile = data));
  }

  public nextReview(): void {
    this.agentFeedback$ = this.realPropertyAgentService.getAgentFeedback(this.agentId, { pageNumber: ++this.pageNumber, pageSize: this.pageSize }).pipe(
      map((res) => res.data),
      tap(({ total }) => (this.totalCount = total)),
      map((data) => data.data.data),
    );
  }

  public prevReview(): void {
    this.agentFeedback$ = this.realPropertyAgentService.getAgentFeedback(this.agentId, { pageNumber: --this.pageNumber, pageSize: this.pageSize }).pipe(
      map((res) => res.data),
      tap(({ total }) => (this.totalCount = total)),
      map((data) => data.data.data),
    );
  }
}
